import { $api } from 'api/http'
import { IUser } from 'api/types/user'

class ProfileApiService {
  getProfile() {
    return $api.get<IUser>('/profile')
  }
}

export const profileApiService = new ProfileApiService()
